import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { FaChartPie, FaBoxes, FaShoppingCart, FaUsers, FaCog, FaSignOutAlt, FaTags, FaHeadset, FaBuilding, FaShareAlt } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

function Sidebar() {
  const navigate = useNavigate();
  const { logout, user, isSeller, isAdmin } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const navLinks = [];

  navLinks.push({ to: '/overview', icon: <FaChartPie />, label: 'Overview' });
  navLinks.push({ to: '/products', icon: <FaBoxes />, label: 'Products' });
  navLinks.push({ to: '/orders', icon: <FaShoppingCart />, label: 'Orders' });
  navLinks.push({ to: '/support-requests', icon: <FaHeadset />, label: 'Support' });

  if (isAdmin) {
    navLinks.push({ to: '/categories', icon: <FaTags />, label: 'Categories' });
    navLinks.push({ to: '/users', icon: <FaUsers />, label: 'Users' });
    navLinks.push({ to: '/vendors', icon: <FaBuilding />, label: 'Vendors' });
    navLinks.push({ to: '/referrals', icon: <FaShareAlt />, label: 'Referrals' });
    navLinks.push({ to: '/settings', icon: <FaCog />, label: 'Settings' });
  }

  // Sellers get access to companies and employees; do not show these links to admins
  if (isSeller && !isAdmin) {
    navLinks.push({ to: '/companies', icon: <FaBuilding />, label: 'Companies' });
    navLinks.push({ to: '/employees', icon: <FaUsers />, label: 'Employees' });
  }

  return (
    <div className="sidebar d-flex flex-column h-100">
      <div className="sidebar-header p-4 border-bottom border-secondary border-opacity-10">
        <h5 className="fw-bold text-white mb-0 ps-3">Admin Dashboard</h5>
      </div>

      <Nav className="flex-column flex-grow-1 py-3">
        {navLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => 
              `nav-link text-white px-4 py-2 d-flex align-items-center ${isActive ? 'active' : ''}`
            }
          >
            <span className="me-2">{link.icon}</span>
            {link.label}
          </NavLink>
        ))}
      </Nav>

      <div className="p-3 border-top border-secondary border-opacity-10">
        <p className="text-white-50 small mb-2">Logged in as {user?.username || 'Admin'}</p>
        <button
          className="btn btn-outline-light btn-sm w-100 d-flex align-items-center justify-content-center"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="me-2" />
          Logout
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
